import { sectionRenderer } from '@theme/section-renderer';

const LOAD_MORE_BUTTON_SELECTOR = '[data-mobile-load-more-button]';
const GRID_SELECTOR = '[ref="grid"]';
const CARD_SELECTOR = '[ref="cards[]"]';

async function loadMore(button) {
  if (!(button instanceof HTMLButtonElement)) return;

  const nextUrlRaw = button.dataset.nextUrl;
  if (!nextUrlRaw) return;

  const resultsList = button.closest('results-list');
  if (!resultsList) return;

  const sectionId = resultsList.getAttribute('section-id');
  if (!sectionId) return;

  const grid = resultsList.querySelector(GRID_SELECTOR);
  if (!(grid instanceof HTMLElement)) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const originalLabel = button.dataset.label ?? button.textContent ?? 'Load More';
  button.textContent = 'Loading…';

  try {
    const nextUrl = new URL(nextUrlRaw, window.location.origin);
    nextUrl.hash = '';

    const html = await sectionRenderer.getSectionHTML(sectionId, true, nextUrl);
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const nextGrid = doc.querySelector(GRID_SELECTOR);
    const newCards = nextGrid ? Array.from(nextGrid.querySelectorAll(CARD_SELECTOR)) : [];
    const firstNewCard = newCards[0] instanceof HTMLElement ? newCards[0] : null;

    if (newCards.length > 0) {
      grid.append(...newCards);
    }

    const nextButton = doc.querySelector(LOAD_MORE_BUTTON_SELECTOR);
    const newNextUrl =
      nextButton instanceof HTMLElement ? nextButton.getAttribute('data-next-url') : null;

    if (newNextUrl) {
      button.dataset.nextUrl = newNextUrl;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    } else {
      button.closest('.mobile-load-more-wrapper')?.remove();
    }

    // Move focus into newly loaded content so it is not lost to body (WCAG 2.4.3).
    if (firstNewCard) {
      const focusTarget =
        firstNewCard.querySelector('a[href], button:not([disabled])') || firstNewCard;
      if (focusTarget instanceof HTMLElement) {
        if (!focusTarget.hasAttribute('tabindex') && focusTarget === firstNewCard) {
          focusTarget.setAttribute('tabindex', '-1');
        }
        focusTarget.focus({ preventScroll: false });
      }
    } else if (document.contains(button)) {
      button.focus();
    }
  } catch (err) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = originalLabel;
    button.focus();
    // Fail silently to avoid breaking the page; console helps debugging.
    // eslint-disable-next-line no-console
    console.error('[mobile-load-more] Failed to load next page', err);
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest(LOAD_MORE_BUTTON_SELECTOR);
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();
  loadMore(button);
});
